(function () {
  Chart.scatterplot = function (params) {
    let data = _.filter(params.data, { clasificacion: "TOS FERINA" });
    let dataAgregada = [];
    const formato = params.formato;
    const el = params.el;
    const partido = params.partido;

    let box = new Box({
      size: { width: 1200, height: 440 },
      padding: { top: 50, right: 60, bottom: 10, left: 60 },
    });

    let svg = null;
    let gPuntos = null;
    let gEjeX = null;
    let gEjeY = null;
    let gLeyenda = null;

    let gLinea = null;
    let gEjeYLinea = null;

    const color = d3
      .scaleOrdinal()
      .domain([+1, +2])
      .range(["#5bcfb8", "#a54cfc"])
      .unknown("#ffff00");

    const x = d3.scaleTime(
      [new Date(2018, 0, 1), new Date(2026, 1, 28)],
      [0, box.content.width],
    );

    const y = d3.scaleLinear().domain([0, 100]).range([box.content.height, 0]);
    const yLinea = d3.scaleLinear().range([box.content.height, 0]);

    const formatTime = d3.utcFormat("%d de %B de %Y");

    function setup() {
      _.each(data, function (d) {
        let arreglo = d.fecha_notificacion.split("-");
        d.fecha_notificacion = new Date(arreglo[0], arreglo[1] - 1, arreglo[2]);
      });

      dataAgregada = _.map(
        _.groupBy(
          _.filter(data, function (d) {
            return d.ev_etiqueta != "DEFUNCION";
          }),
          "fecha_notificacion",
        ),
        function (v, k) {
          return { fecha_notificacion: new Date(k), n: v.length };
        },
      );
      dataAgregada.sort((a, b) => a.fecha_notificacion - b.fecha_notificacion);
      data = _.filter(data, { ev_etiqueta: "DEFUNCION" });

      yLinea.domain([0, _.max(_.map(dataAgregada, "n"))]);

      crearSVG(el);
      crearScatterplot();
      crearLinea();
      crearLeyenda();
    }

    function crearLeyenda() {
      let arreglo = [1, 2];
      let l = 20;
      let espacio = 10;
      let valY = 0;
      let valX = 0;

      /*
      gLeyenda.append("text").text("Sexo").attr("x", 0).attr("y", valY);

      valY += espacio;
      */

      let g = null;
      _.each(arreglo, function (d) {
        let colorRelleno = color(d);
        let texto = d == 1 ? "Defunción masculina" : "Defunción femenina";
        g = gLeyenda.append("g");

        g.append("circle")
          .style("fill", "transparent")
          .style("stroke", colorRelleno)
          .style("stroke-width", "3px")
          .style("opacity", 0.6)
          .attr("r", 8)
          .attr("cx", valX + 12)
          .attr("cy", valY + 11);
        //.attr("width", l)
        //.attr("height", l);

        g.append("text")
          .text(texto)
          .attr("x", valX + l + espacio / 2)
          .attr("y", valY + l / 2 + 3)
          .attr("dominant-baseline", "middle");

        let rect = g.node().getBBox();

        valX += rect.width + l;

        //valY += espacio + l;
      });

      g = gLeyenda.append("g");

      g.append("circle")
        .style("fill", "#c3d8ff")
        .style("stroke-width", "3px")
        .style("opacity", 0.6)
        .attr("r", 2)
        .attr("cx", valX + 12)
        .attr("cy", valY + 11);
      //.attr("width", l)
      //.attr("height", l);

      g.append("text")
        .text("Contagios sin defunción")
        .attr("x", valX + l + espacio / 2)
        .attr("y", valY + l / 2 + 3)
        .attr("dominant-baseline", "middle");

      let rect = gLeyenda.node().getBBox();

      gLeyenda.attr(
        "transform",
        `translate(${(box.width - rect.width) / 2},0)`,
      );
    }

    function crearSVG(wrapper) {
      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height}`);

      gLeyenda = svg.append("g").attr("data-g", "gLeyenda");

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top})`,
        );

      gEjeX = svg.append("g").attr("data-g", "gEjeX");

      gEjeX
        .call(
          d3
            .axisTop(x)
            .tickSizeInner(-box.content.height)
            .tickSizeOuter(0)
            .tickValues([
              new Date(2019, 0, 1),
              new Date(2021, 0, 1),
              new Date(2023, 0, 1),
              new Date(2025, 0, 1),
            ]),
        )
        .select(".domain")
        .remove();

      gEjeX
        .append("text")
        .attr("text-anchor", "middle")
        .attr("transform", `translate(0,${box.content.height / 2})rotate(270)`)
        .text("Edad en años")
        .attr("y", -30)
        .attr("font-size", "18px");

      gEjeYLinea = svg.append("g");
      gEjeYLinea
        .attr("data-g", "gEjeY")
        .attr("transform", `translate(${box.content.width}, 0)`)
        .call(
          d3
            .axisRight(yLinea)
            .tickValues([0, 2, 4, 6, 8, 10, 12, 14])
            .tickSizeInner(0)
            .tickSizeOuter(0),
        )
        .select(".domain")
        .remove();

      gEjeYLinea.selectAll("text").style("fill", "#83abf5");
      gEjeYLinea
        .append("text")
        .attr("text-anchor", "middle")
        .attr("transform", `translate(0,${box.content.height / 2})rotate(90)`)
        .text("Número de contagios")
        .attr("y", -30)
        .attr("font-size", "18px");

      gEjeY = svg
        .append("g")
        .attr("data-g", "gEjeY")
        .call(
          d3
            .axisLeft(y)
            //.tickValues([0, 20, 40, 60, 80])
            .tickSizeInner(-box.content.width)
            .tickSizeOuter(0),
        )
        .select(".domain")
        .remove();

      gLinea = svg.append("g").attr("data-g", "gLinea");

      gPuntos = svg.append("g").attr("data-g", "gPuntos");
    }

    function crearScatterplot() {
      gPuntos
        .selectAll("circle")
        .data(data)
        .join("circle")
        .attr("cx", function (d) {
          return x(d.fecha_notificacion);
        })
        .attr("cy", function (d) {
          return y(d.edad);
        })
        .attr("r", 8)
        .style("fill", "transparent")
        .style("stroke", (d) => color(d.sexo))
        .style("stroke-width", 3)
        .style("opacity", 0.6)
        .on("mouseover", crearTooltip);
    }

    function crearTooltip(ev, d) {
      ev.preventDefault();
      let el = d3.select(this).node();
      tippy(el, {
        content: `<strong>Edad: </strong>${d.grupo_edad} años<br><strong>Sexo: </strong>${d.sexo == 1 ? "Masculino" : "Femenino"}<br><strong>Fecha</strong>: ${formatTime(d.fecha_notificacion)}<br><strong>Estado: </strong>${d.entidad_residencia}`,
        allowHTML: true,
      });
    }

    function crearLinea() {
      let arreglo = _.filter(params.data, function (d) {
        return (
          d.ev_etiqueta != "DEFUNCION" &&
          d.clasificacion == "TOS FERINA" &&
          d.edad != "#REF!"
        );
      });
      arreglo = _.orderBy(
        arreglo,
        ["fecha_notificacion", "edad"],
        ["asc", "asc"],
      );
      gLinea
        .append("path")
        .datum(dataAgregada)
        //.datum(arreglo)
        .attr("fill", "none")
        .attr("stroke", "#c3d8ff")
        .attr("stroke-width", 1)
        /*
        .attr("cx", function (d) {
          return x(d.fecha_notificacion);
        })
        .attr("cy", function (d) {
          return y(d.edad);
        })
         */
        .attr(
          "d",
          d3
            .line()
            //.curve(d3.curveBasis)
            .x(function (d) {
              return x(d.fecha_notificacion);
            })
            .y(function (d) {
              return yLinea(d.n);
            }),
        );

      gLinea
        .selectAll("circle")
        .data(dataAgregada)
        .join("circle")
        .attr("cx", function (d) {
          return x(d.fecha_notificacion);
        })
        .attr("cy", function (d) {
          return yLinea(d.n);
        })
        .attr("r", 2)
        .style("fill", "#c3d8ff")
        .on("mouseover", crearTooltipLite);
    }

    function crearTooltipLite(ev, d) {
      ev.preventDefault();
      let el = d3.select(this).node();
      tippy(el, {
        content: `<strong>Contagios: </strong>${d.n}<br><strong>Fecha</strong>: ${formatTime(d.fecha_notificacion)}`,
        allowHTML: true,
      });
    }

    return setup();
  };
})();
